module.exports = __webpack_public_path__ + "img/events-detail.cc948eeb.jpg";